import type { ErpEnvironment } from '@/shared/erp/erpEnvironment';
import { extranetApiClient } from './extranetApiClient';

/**
 * The lean registry payload of `GET /extranet/erp/registries` (contract §5):
 * the tenant's registries linked to the extranet module — one per VEOS
 * environment. Feeds the shared non-production `ErpEnvironmentBanner`.
 */
export interface ExtranetErpRegistry {
  slug: string;
  name: string;
  base_url: string;
  environment: ErpEnvironment | null;
  is_main: boolean;
}

interface ExtranetErpRegistriesResponse {
  data: ExtranetErpRegistry[];
}

export const erpRegistriesService = {
  /** The current tenant's extranet registries (auth + `X-Tenant-ID` added by the client). */
  async fetchAll(): Promise<ExtranetErpRegistry[]> {
    const response = await extranetApiClient.get<ExtranetErpRegistriesResponse>(
      '/extranet/erp/registries',
    );
    return response.data.data;
  },
};
